import type { Location } from "./types";

/**
 * Bootstrap fixtures — a representative sample of UL locations across countries
 * and partner chains. The full 18-location dataset that the demo uses lives in
 * `UL_Demo_Consumer_Locator.html` (search for `const MOCK = [`); copy it here
 * if you need the wider mix.
 */
export const MOCK_LOCATIONS: Location[] = [
  // ---- USA ----
  {
    location_id: "LOC-US-00482",
    agent_id: "PARTY-2241",
    name: "Walmart Supercenter — Aurora",
    partner_chain: {
      slug: "walmart",
      display_name: "Walmart",
      logo_url: "",
    },
    address: {
      line1: "14000 E Exposition Ave",
      city: "Aurora",
      state_province: "CO",
      postal_code: "80012",
      country: "US",
    },
    geo: { lat: 39.7099, lng: -104.81 },
    phone: "+1 303-340-3445",
    hours: {
      monday: ["06:00", "23:00"],
      tuesday: ["06:00", "23:00"],
      wednesday: ["06:00", "23:00"],
      thursday: ["06:00", "23:00"],
      friday: ["06:00", "23:00"],
      saturday: ["06:00", "23:00"],
      sunday: ["06:00", "23:00"],
      tz: "America/Denver",
    },
    services: {
      send_money: true,
      receive_money: true,
      money_order: true,
      bill_pay: true,
      mobile_topup: true,
      crypto_buy: false,
      send_currencies: ["USD"],
      rec_currencies: ["USD"],
      max_send_amount_usd: 6000,
    },
    is_top_rated: true,
    is_mg_exclusive: false,
    rating: 4.6,
    rating_count: 1820,
    avg_wait_minutes: 4,
    distance_miles: 1.4,
    listing: {
      listed_google: true,
      google_verified: true,
      short_description:
        "Send and receive money inside Walmart's 24/7 service desk.",
    },
  },
  {
    location_id: "LOC-US-00691",
    agent_id: "PARTY-9981",
    name: "CVS Pharmacy #4188 — Capitol Hill",
    partner_chain: {
      slug: "cvs",
      display_name: "CVS",
    },
    address: {
      line1: "517 E Colfax Ave",
      city: "Denver",
      state_province: "CO",
      postal_code: "80203",
      country: "US",
    },
    geo: { lat: 39.7395, lng: -104.978 },
    hours: {
      monday: ["07:00", "22:00"],
      tuesday: ["07:00", "22:00"],
      wednesday: ["07:00", "22:00"],
      thursday: ["07:00", "22:00"],
      friday: ["07:00", "22:00"],
      saturday: ["08:00", "21:00"],
      sunday: ["09:00", "20:00"],
      tz: "America/Denver",
    },
    services: {
      send_money: true,
      receive_money: true,
      bill_pay: true,
      money_order: false,
      send_currencies: ["USD"],
      rec_currencies: ["USD"],
      max_send_amount_usd: 3000,
    },
    rating: 4.1,
    rating_count: 412,
    avg_wait_minutes: 7,
    distance_miles: 0.8,
  },
  {
    location_id: "LOC-US-00204",
    name: "ACE Cash Express — Chicago Loop",
    partner_chain: { slug: "ace_cash_express", display_name: "ACE Cash Express" },
    address: {
      line1: "111 W Jackson Blvd",
      city: "Chicago",
      state_province: "IL",
      postal_code: "60604",
      country: "US",
    },
    geo: { lat: 41.8779, lng: -87.6312 },
    hours: { tz: "America/Chicago" },
    services: {
      send_money: true,
      receive_money: true,
      money_order: true,
      bill_pay: true,
      crypto_buy: true,
      crypto_sell: true,
      send_currencies: ["USD"],
      rec_currencies: ["USD", "MXN"],
    },
    is_crypto_eligible: true,
    is_top_rated: true,
    rating: 4.4,
    rating_count: 980,
    avg_wait_minutes: 3,
    distance_miles: 0.4,
  },
  // ---- Mexico ----
  {
    location_id: "LOC-MX-00112",
    name: "OXXO Centro — Guadalajara",
    partner_chain: { slug: "oxxo", display_name: "OXXO" },
    address: {
      line1: "Av Juárez 234",
      city: "Guadalajara",
      state_province: "JAL",
      postal_code: "44100",
      country: "MX",
    },
    geo: { lat: 20.6765, lng: -103.347 },
    hours: { tz: "America/Mexico_City" },
    services: {
      send_money: true,
      receive_money: true,
      mobile_topup: true,
      send_currencies: ["MXN"],
      rec_currencies: ["MXN", "USD"],
    },
    rating: 4.0,
    rating_count: 245,
    distance_miles: 6.2,
  },
  // ---- UK ----
  {
    location_id: "LOC-GB-00318",
    name: "Post Office — High Street Kensington",
    partner_chain: { slug: "post_office", display_name: "Post Office" },
    address: {
      line1: "1 Derry St",
      city: "London",
      postal_code: "W8 5HD",
      country: "GB",
    },
    geo: { lat: 51.5008, lng: -0.1898 },
    hours: { tz: "Europe/London" },
    services: {
      send_money: true,
      receive_money: true,
      bill_pay: false,
      send_currencies: ["GBP"],
      rec_currencies: ["GBP", "EUR", "USD"],
    },
    is_mg_exclusive: false,
    rating: 4.3,
    rating_count: 612,
    distance_miles: 12.8,
  },
];
